var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewportTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "viewportTwo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.752,
    height: 111,
    viewBox: "0 0 135.752 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    fill: "none",
    stroke: "#f6c543",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.752,
    height: 51,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 127.752,
    height: 43,
    rx: 14,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    transform: "translate(0 60)",
    fill: "none",
    stroke: "#b5d36d",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.752,
    height: 51,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 127.752,
    height: 43,
    rx: 14,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewportTwo);
export default __webpack_public_path__ + "static/media/viewportTwo.5c16125bd2f1ab0d061777c37888cc3f.svg";
export { ForwardRef as ReactComponent };